import { LinkListItem } from "../components/link-list";
import { DataFolderAnnouncementsResponse } from "../core/interfaces/OcontentResponses";
import ProviderFactory from "../core/ProviderFactory";
import OcontentAnnouncementsProvider from "../core/providers/ocontent/OcontentAnnouncementsProvider";
import OcontentEventVideoReplayProvider from "../core/providers/ocontent/OcontentEventVideoReplayProvider";
import OcontentIntroTextProvider from "../core/providers/ocontent/OcontentIntroTextProvider";
import OcontentMiscProvider from "../core/providers/ocontent/OcontentMiscProvider";
import OcontentQuicklinsProvider from "../core/providers/ocontent/OcontentQuicklinksProvider";
import OcontentYoutubeProvider from "../core/providers/ocontent/OcontentYoutubeProvider";
import { UpcomingEventsConfiguration } from "../core/types/UpcomingEventsConfigurations";
import { EventSearchDefaults } from "../core/types/EventSearchDefaults";
import {
  OcontentProviderType,
  ProviderConfiguration,
} from "../core/types/Provider";
import { Spotlight } from "../core/types/Spotlight";
export default abstract class OContentModel {
  private static introTextProvider: OcontentIntroTextProvider =
    ProviderFactory.create(
      OcontentProviderType.IntroText,
      ProviderConfiguration.ocontent
    );
  private static quicklinksProvider: OcontentQuicklinsProvider =
    ProviderFactory.create(
      OcontentProviderType.Quicklinks,
      ProviderConfiguration.ocontent
    );
  private static youtubeProvider: OcontentYoutubeProvider =
    ProviderFactory.create(
      OcontentProviderType.Youtube,
      ProviderConfiguration.ocontent
    );
  private static annProvider: OcontentAnnouncementsProvider =
    ProviderFactory.create(
      OcontentProviderType.Announcements,
      ProviderConfiguration.ocontent
    );
  private static evrProvder: OcontentEventVideoReplayProvider =
    ProviderFactory.create(
      OcontentProviderType.EventVideoReplay,
      ProviderConfiguration.ocontent
    );

  private static miscProvider: OcontentMiscProvider = ProviderFactory.create(
    OcontentProviderType.Misc,
    ProviderConfiguration.ocontent
  );

  public static async getIntroTextData(catName: string): Promise<string> {
    try {
      const html = await OContentModel.introTextProvider.getIntroTextData(
        catName
      );
      return html;
    } catch (err) {
      console.error(err);

      return "";
    }
  }

  public static async getQuickLinksData(
    catName: string
  ): Promise<LinkListItem[]> {
    try {
      const json = await OContentModel.quicklinksProvider.getQuicklinks(
        catName
      );
      console.log(json);
      return json;
    } catch (err) {
      console.error(err);

      return [];
    }
  }

  public static async getYoutubePanel(catName: string): Promise<string> {
    return await OContentModel.youtubeProvider.getHtml(catName);
  }

  public static async getAnnouncementsConfig(
    catName: string
  ): Promise<Array<DataFolderAnnouncementsResponse>> {
    return await OContentModel.annProvider.getConfig(catName);
  }

  public static getEventVideoReplay(eventName: string): Promise<string> {
    return OContentModel.evrProvder.getEventVideoReplay(eventName);
  }

  public static async getSpotlights(): Promise<Array<Spotlight>> {
    const spotlights = await OContentModel.miscProvider.getSpotlightData();
    return spotlights ? spotlights : [];
  }

  public static async getInternalSpotlights(): Promise<Array<Spotlight>> {
    const spotlights =
      await OContentModel.miscProvider.getInternalSpotlightData();
    return spotlights ? spotlights : [];
  }

  public static async getEventSearchDefaults(): Promise<
    Array<EventSearchDefaults>
  > {
    const eventSearchDefaults =
      await OContentModel.miscProvider.getEventSearchDefaultsData();

    return eventSearchDefaults ? eventSearchDefaults : [];
  }

  public static async getUpcomingEventsConfigurationsForCategory(
    catName: string
  ): Promise<UpcomingEventsConfiguration | null> {
    const eventConfigs =
      await OContentModel.miscProvider.getUpcomingEventsConfigurations();
    const configForCat = eventConfigs.filter((config) =>
      catName.includes(config.prefix)
    );
    return configForCat ? configForCat[0] : null;
  }
}
